import { getRecycleList, getRuleCondition, addRecycle, delRecycle } from '@/services/confingAutoWithdraw'
import i18n from '@/lib/language'

export default {
  namespaced: true,
  state: {
    columns: [{
      title: i18n.t('message[1751]'), // '规则内容'
      dataIndex: 'tips',
      key: 'tips',
      slots: { title: 'tips' },
      scopedSlots: { customRender: 'tips' },
      width: 840
    }, {
      title: i18n.t('message[79]'), // '操作'
      dataIndex: 'action',
      slots: { title: 'action' },
      scopedSlots: { customRender: 'action' },
      width: 200
    }],
    listDatas: [{
      id: 1,
      tips: '【信息类型=无效，跟进状态=丢单】时自动收回到【待分配】并重置信息分级'
    }],
    loading: true,
    ruleCondition: null
  },

  mutations: {
    setListDatas (state, data) {
      state.listDatas = data
    },
    SET_LOADING (state, data) {
      state.loading = data
    },
    setRuleCondition (state, data) {
      state.ruleCondition = data
    }
  },
  actions: {
    async fetchRecycleList ({ commit }, params) {
      commit('SET_LOADING', true)
      let chain = await getRecycleList()
      chain
        .params(params)
        .onSuccess((raw = {}) => {
          commit('setListDatas', raw.list || [])
          commit('SET_LOADING', false)
        })
        .fetch()
      return chain
    },
    async fetchRuleCondition ({ commit }, params) {
      let chain = await getRuleCondition()
      chain
        .params(params)
        .onSuccess((raw = {}) => {
          commit('setRuleCondition', raw)
        })
        .fetch()
      return chain
    },

    async addRecycle ({ commit, dispatch }, params) {
      let chain = await addRecycle()
      chain
        .params(params)
        .onSuccess(res => {
          dispatch('fetchRecycleList')
        })
        .fetch()
      return chain
    },
    async delRecycle ({ commit }, params) {
      let chain = await delRecycle()
      chain
        .params(params)
        .fetch()
      return chain
    }
  }
}
